import React from 'react'
import { SectionSAndF, SectionTitle, Social } from './styles'
import { MapSocial } from './mapSocial'
import { FooterSocial } from 'src/constants'
import { useTranslations } from 'src/provider/LocaleProvider'

export const SocialCard = () => {
    const t = useTranslations()
    return (
        <SectionSAndF marginTop={'xxmedium'}>
            <SectionTitle variant={'h2'} fontSize={'medium'} fontWeight={600}>
                {t('blog.recentBlog.subscribeFollow')}
            </SectionTitle>
            <Social marginTop={'xxmedium'}>
                {FooterSocial.map((social) => {
                    return <MapSocial key={social.id} {...social} />
                })}
            </Social>
        </SectionSAndF>
    )
}
